import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const CardDetailsModalPriceSkeleton: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <Skeleton className="h-6 w-56 mx-auto" />
      </CardHeader>
      <CardContent>
        <div className="text-center space-y-3">
          <Skeleton className="h-8 w-40 mx-auto" />
          <Skeleton className="h-4 w-28 mx-auto" />
        </div>
      </CardContent>
    </Card>
  );
};

export default CardDetailsModalPriceSkeleton;
